import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { PropertyValueResource, ActionTemplateParameterResource } from "@octopusdeploy/octopus-server-client";
import type { CommonTemplatesChangeTracker, CommonTemplatesKey } from "~/areas/projects/components/Variables/TenantVariables/useCommonTemplatesChangeTracker";
import type { DoBusyTask } from "~/components/DataBaseComponent/index";
import type { SourceItems } from "~/components/TenantVariableInput/TenantVariableInput";
import TenantVariableInput from "~/components/TenantVariableInput/TenantVariableInput";
interface CommonTemplateValueEditProps {
    template: ActionTemplateParameterResource;
    value: PropertyValueResource | undefined;
    sourceItems: SourceItems;
    doBusyTask: DoBusyTask;
    changeTracker: CommonTemplatesChangeTracker;
    valueKey: CommonTemplatesKey;
    bindableTemplateNames: string[];
    initialValue: PropertyValueResource | undefined;
    initialEnvironmentIds: string[];
}
export default ({ template, value, sourceItems, doBusyTask, changeTracker, valueKey, bindableTemplateNames, initialValue, initialEnvironmentIds }: CommonTemplateValueEditProps) => {
    const isValueUnchanged = (value1: PropertyValueResource | undefined, value2: PropertyValueResource | undefined): boolean => value1 === value2;
    const isEnvironmentIdsUnchanged = (initialEnvironments: string[], currentEnvironments: string[]): boolean => {
        if (currentEnvironments.length !== initialEnvironments.length) {
            return false;
        }
        return currentEnvironments.every((id, i) => id === initialEnvironments[i]);
    };
    const handleChange = (newValue: PropertyValueResource | undefined) => {
        const entry = changeTracker.has(valueKey) ? changeTracker.get(valueKey) : undefined;
        const currentEnvironmentIds = entry?.environmentIds || initialEnvironmentIds;
        const valueUnchanged = isValueUnchanged(newValue, initialValue);
        const environmentIdsUnchanged = isEnvironmentIdsUnchanged(initialEnvironmentIds, currentEnvironmentIds);
        if (valueUnchanged && environmentIdsUnchanged) {
            changeTracker.remove(valueKey);
        }
        else {
            changeTracker.set(valueKey, { value: newValue, environmentIds: currentEnvironmentIds });
        }
    };
    return (<div className={editStyles.container}>
            <TenantVariableInput variableTemplate={template} sourceItems={sourceItems} localNames={bindableTemplateNames} doBusyTask={doBusyTask} value={value} warning={template.DefaultValue || value ? undefined : "Value required for deployment"} onChange={(newValue) => handleChange(newValue)} hideSearch={true} autoFocus={true}/>
        </div>);
};
const editStyles = {
    container: css({
        padding: `${space[12]} ${space[12]} ${space[4]} ${space[12]}`,
    }),
};
